import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import { Link } from 'react-router-dom';

import Contact from './Contact';
import Menu from './Menu';
import ThemeToggleButton from './ThemeToggleButton';
import Logo from '../assets/Logo';
import { useAppContext } from '../hooks/AppProvider';
import { trackEvent } from '../modules/matomo';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(5px)',
  backgroundColor: theme.palette.background.transparent,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    alignItems: 'center',
    gap: theme.spacing(0),
  },
  '@media (max-width: 480px) and (max-height: 480px)': {
    flexDirection: 'row',
    minHeight: 64,
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '.borderBox': {
    borderLeft: '1px solid',
    borderColor: theme.palette.divider,
    marginLeft: theme.spacing(1),
  },
  '@media (max-width: 480px) and (max-height: 480px)': {
    flexShrink: 0,
    gap: 0,
    '.borderBox': {
      marginLeft: theme.spacing(0.5),
    },
  },
}));

const StyledLogoLink = styled(Link)(({ theme }) => ({
  display: 'block',
  maxWidth: 342,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: 'none',
    width: 'auto',
  },
  '@media (max-width: 480px) and (max-height: 480px)': {
    maxWidth: 112,
    '& > div': {
      padding: 0,
    },
    svg: {
      height: 48,
      width: '100%',
    },
  },
}));

const Header = () => {
  const { reducedMotion } = useAppContext();

  return (
    <StyledAppBar position="fixed" color='transparent'>
      <Container maxWidth="100%">
        <StyledToolbar disableGutters>
          <StyledLogoLink
            aria-label="mk mediaconcept GbR Logo"
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
              trackEvent('Logo', 'Click', 'Header');
            }}
          >
            <Logo />
          </StyledLogoLink>
          <StyledBox>
            <Contact />
            <ThemeToggleButton />
            <Menu />
          </StyledBox>
        </StyledToolbar>
      </Container>
    </StyledAppBar>
  );
};

export default Header;
